import { render } from "./ToolReports.vue?vue&type=template&id=4701d265"
import script from "./ToolReports.vue?vue&type=script&lang=js"
export * from "./ToolReports.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__